import { i18nConstants, generalConstants } from '@tweddle-se-team/common/constants'
import { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { ContentContainer } from '@/components/styles'
import ContentHeader from '../shared/contentHeader'
import { productSelectors } from '@/store/products'
import useTranslation from '@/hooks/useTranslation'
import { configSelectors } from '@/store/configs'
import { i18nL10nSelectors } from '@/store/i18nL10n'
import ChooseVehicle from './chooseVehicle'
import { searchActions } from '@/store/search'
import VinSearch from './vinSearch'

const { rtlLanguagesISO2Codes } = i18nConstants
const { BRANDS } = generalConstants

const Landing = () => {
  const dispatch = useDispatch()
  const products = useSelector(productSelectors.selectProducts)
  const i18nL10n = useSelector(i18nL10nSelectors.selectI18nL10n)
  const modelLangMarketingNames = useSelector(configSelectors.selectConfigByKey('modelLangMarketingNames'))
  const t = useTranslation()
  const { locale } = i18nL10n
  const {
    filterBy: { brand }
  } = products

  const isLexus = brand.toLowerCase() === BRANDS.LEXUS

  useEffect(() => {
    // Reset search status when going back to landing page
    dispatch(searchActions.SET_PANE({}))
    dispatch(searchActions.RESET_FILTERS())
  }, [dispatch])

  return (
    <div>
      <ContentContainer $rightAlign={rtlLanguagesISO2Codes.includes(locale)}>
        <ContentHeader brand paragraph divider={!isLexus} rtl={rtlLanguagesISO2Codes.includes(locale)} useHeaderTag />
      </ContentContainer>
      <ContentContainer $rightAlign={rtlLanguagesISO2Codes.includes(locale)}>
        <p>{t(`promo_text_${brand.toLowerCase()}`)}</p>
      </ContentContainer>
      <ContentContainer $rightAlign={rtlLanguagesISO2Codes.includes(locale)}>
        <VinSearch i18nL10n={i18nL10n} products={products} />
        <ChooseVehicle i18nL10n={i18nL10n} products={products} modelLangMarketingNames={modelLangMarketingNames} />
        <div className="mb-30" />
      </ContentContainer>
    </div>
  )
}

export default Landing
